var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6391_2795",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 26,
    fill: "url(#pattern1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6391_2795)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 26
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6391_2795",
    transform: "matrix(0.0108696 0 0 0.0138889 -0.0434783 -0.194444)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6391_2795",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABYUlEQVR4nO3csU7DMBQF0H4M8UqdJRZfADMfhfqTDIDExIgYgxrYkyhq/eqcI70pUuX2ymmSq/ZwAAAAAACgQXd5eO7y8JX6Ms7MezoOT7XX27wul88FYfxNLm+119u8xWH8T+31Nk8gwcztgLnjXT+cUh5+1ga7t+n68rroO3hLIN39w7H2G003NcOHQPodBTLtklxeUi7f9d9safOUNTezL8g2AglmugNfukPcGF7e+bx2/qCXhJFyebzCkgAAALgmnXowOvVgPFwMRiDBbC6odOrjRQuqNcd16mVlc6hTH3cVyLRLdOqjTr1lrrKC0akHo1MHAADYOZ16MDr1YDxcDEYgwejUS+wffa45rlMvsSpcgZRYgUyh6NRHnXrLXGUFo1MPRqcOAACwczr1YHTqwXi4GIxAgtGpF536fmfQqafqIejUx4jjv99v1dqka6+3eTr1YHTqAAAAAABw2OgXhsZxD+nn2t0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/ListIcon.beda75049c1f229e066224d999c8a7e7.svg";
export { ForwardRef as ReactComponent };